import React, { useMemo } from 'react'
import ReceivedMessage from './ReceivedMessage'
import SentMessage from './SentMessage'
interface Props {
  message: string
  author: string
  type: 'my' | 'other'
  groupMessageType: 'first' | 'last' | 'middle' | 'single'
  translateMessage: (messageId: number, message: string) => void
  id: number
  translated: boolean
}

const Message = ({ message, type, author, groupMessageType, translateMessage, id, translated }: Props) => {
  if (type === 'other')
    return (
      <ReceivedMessage
        message={message}
        author={author}
        groupMessageType={groupMessageType}
        translateMessage={translateMessage}
        id={id}
        translated={translated}
      />
    )
  return (
    <SentMessage
      translateMessage={translateMessage}
      message={message}
      author={author}
      groupMessageType={groupMessageType}
      id={id}
      translated={translated}
    />
  )
}

export default Message
